export default "__VITE_ASSET__DctQGk_L__"